import * as React from 'react';
import type { SVGProps } from 'react';
const SvgOther = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 64 70"
    {...props}
  >
    <path
      stroke="#4B7EFF"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={3}
      d="m23.317 59.57 1.948 4.382a7.374 7.374 0 0 0 13.482 0l1.948-4.382a8.1 8.1 0 0 1 3.333-3.703 8.1 8.1 0 0 1 4.9-1.041l4.767.507a7.374 7.374 0 0 0 8.142-7.723 7.37 7.37 0 0 0-1.402-3.95l-2.822-3.879A8.1 8.1 0 0 1 56.08 35c0-1.711.542-3.379 1.548-4.763l2.822-3.878a7.37 7.37 0 0 0 .422-8.026 7.37 7.37 0 0 0-7.162-3.648l-4.767.508a8.1 8.1 0 0 1-4.9-1.041 8.1 8.1 0 0 1-3.333-3.722l-1.963-4.382a7.374 7.374 0 0 0-10.761-3.19 7.37 7.37 0 0 0-2.72 3.19l-1.949 4.382a8.1 8.1 0 0 1-3.333 3.722 8.1 8.1 0 0 1-4.9 1.04l-4.782-.507a7.37 7.37 0 0 0-7.163 3.648 7.37 7.37 0 0 0 .422 8.026l2.823 3.878a8.1 8.1 0 0 1 0 9.526L3.56 43.64a7.37 7.37 0 0 0 2.62 10.91 7.4 7.4 0 0 0 4.121.764l4.767-.508a8.1 8.1 0 0 1 4.9 1.041 8.1 8.1 0 0 1 3.348 3.722"
    />
    <path
      stroke="#4B7EFF"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={3}
      d="M32 45c5.523 0 10-4.477 10-10s-4.477-10-10-10-10 4.477-10 10 4.477 10 10 10"
    />
  </svg>
);
export default SvgOther;
